export enum LinkSource {
  MP3QURAN = 'mp3quran.net',
  ITQAN = 'itqan.dev',
  ISLAMHOUSE = 'islamhouse.com',
  INTERNETARCHIVE = 'archive.org',
  UNKNOWN = 'unknown',
}
